import { render, staticRenderFns } from "./fillquestionnaire2.vue?vue&type=template&id=745b0b57&scoped=true"
import script from "./fillquestionnaire2.vue?vue&type=script&lang=js"
export * from "./fillquestionnaire2.vue?vue&type=script&lang=js"
import style0 from "./fillquestionnaire2.vue?vue&type=style&index=0&id=745b0b57&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745b0b57",
  null
  
)

export default component.exports